import { AlertTriangle } from "lucide-react";

/**
 * Gmail recorta los mensajes que superan ~102 KB de HTML ("[Mensaje
 * recortado] Ver todo el mensaje"), ocultando el resto del email al
 * destinatario (incluido el píxel de apertura y el pie de baja, que se
 * inyectan al final). Se avisa a partir de 90 KB, con margen para lo que se
 * añade en el envío (tracking de enlaces, píxel, pie de baja).
 */
const GMAIL_CLIP_WARNING_BYTES = 90 * 1024;

interface EmailHtmlSizeNoticeProps {
  html: string;
}

/**
 * Aviso discreto (sin pop-ups del sistema) con el tamaño del HTML del email
 * que se está componiendo. Por debajo del umbral solo informa el peso; al
 * superarlo, avisa de que Gmail puede recortar el mensaje.
 */
export default function EmailHtmlSizeNotice({ html }: EmailHtmlSizeNoticeProps) {
  const sizeBytes = new TextEncoder().encode(html || "").length;
  const sizeKb = Math.max(0, Math.round(sizeBytes / 1024));

  if (sizeBytes <= GMAIL_CLIP_WARNING_BYTES) {
    return (
      <p className="mt-2 text-xs text-gray-400">Tamaño del email: {sizeKb} KB</p>
    );
  }

  return (
    <div className="mt-2 flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg p-2.5 text-xs text-amber-700">
      <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
      <span>
        Este email pesa <strong>{sizeKb} KB</strong>. Gmail recorta los
        mensajes que superan ~100 KB (el destinatario vería solo una parte,
        con un enlace de &ldquo;Ver mensaje completo&rdquo;). Reduce el
        contenido o el tamaño de las imágenes para evitarlo.
      </span>
    </div>
  );
}
